<template>
  <div class="flex items-center relative border-b-2" :class="{ 'border-red-500': filterValue !== '' }">
    <font-awesome-icon :icon="['far', 'search']" class="absolute text-gray-500" :class="{ 'text-red-500': filterValue !== '' }" />
    <input class="bg-white border-0 w-full p-1 pl-6 focus:bg-white font-bold text-sm uppercase"
      type="text" :placeholder="placeholder" ref="" v-model="filterValue"  />
    <button class="absolute right-0 px-1" v-if="filterValue !== ''" @click="filterValue = ''">
      <font-awesome-icon :icon="['far', 'times']" class="text-gray-500" :class="{ 'text-red-500': filterValue !== '' }" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'filter-input',
  props: ['value', 'placeholder'],
  computed: {
    filterValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style scoped>
  input::placeholder {
    @apply uppercase font-bold text-sm text-gray-700
  }
</style>